export default __webpack_public_path__ + "static/media/slide1_w_bg.1f902e9c.png";